import React, { Component } from 'react';

class Warning extends Component {
    state = {  }
    render() { 
        return ( 
            <div className="bg-warning">
                <div className="warning-content">
                    <div className="warning-image">
                        <img src={require("../images/oops.png")} width="100%" alt=""/>
                    </div>
                    <h3 className="cent">It seems this site is temporarily down</h3>
                </div>
            </div>
         );
    }
}
 
export default Warning;